<nb-card class="organizations-page">
  <nb-card-header>
    <div class="header-row">
      <span>{{ 'organizations' | translate }}</span>
      <input nbInput
             type="text"
             class="search-input"
             [ngModel]="searchQuery"
             (ngModelChange)="onSearch($event)"
             [placeholder]="'search' | translate">
    </div>
  </nb-card-header>

  <nb-card-body>
    <div *ngIf="errorMessage" class="error-banner">{{ errorMessage }}</div>
    <div *ngIf="isLoading">{{ 'loading' | translate }}</div>

    <table class="org-table" *ngIf="!isLoading && organizations.length">
      <thead>
        <tr>
          <th class="sortable" (click)="toggleSort('canonical_name')">
            {{ 'name' | translate }}
            <span *ngIf="sort === 'canonical_name'">{{ direction === 'asc' ? '&uarr;' : '&darr;' }}</span>
          </th>
          <th>{{ 'scrapedvacancies' | translate }}</th>
          <!--
            "Status" read as the organisation's status. It is not: it is this
            tenant's relationship to the organisation, derived from whether a
            Client record exists here and what state it is in. The values were
            already legible, the column heading was what made them mean the
            wrong thing.
          -->
          <th [nbTooltip]="'orgrelationshiphelp' | translate">
            {{ 'orgrelationship' | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let org of organizations" (click)="open(org)" class="org-row">
          <td>{{ org.canonical_name }}</td>
          <td>{{ org.market_vacancies_count ?? 0 }}</td>
          <td>
            <span class="chip chip-{{ tracking(org) }}">{{ tracking(org) | translate }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <div *ngIf="!isLoading && !organizations.length && !errorMessage" class="empty-state">
      {{ 'noresults' | translate }}
    </div>

    <!--
      The shared control Market overview paginates with, rather than the two
      arrows and "1 / 13" that used to live here. Rendered whenever there are
      rows, not only past page 1, because the page-size selector is useful on a
      single page too.
    -->
    <bst-pager *ngIf="paged"
               [paged]="paged"
               [disabled]="loading | async"
               [pageSize]="perPage"
               [pageSizeOptions]="pageSizeOptions"
               (pageChange)="load($event)"
               (pageSizeChange)="changePageSize($event)"></bst-pager>
  </nb-card-body>
</nb-card>
